export default [
  {
    dataField: 'id',
    caption: 'ID',
    dataType: 'integer',
    width: 50
  },
  {
    dataField: 'cidade',
    caption: 'Nome'
  },
  {
    dataField: 'uf',
    caption: 'UF'
  }
]
